import React from 'react'

import { Box, Button, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import { useForm } from 'modules/core/hooks/useForm'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import SettingsGroup from 'modules/security_settings/components/SettingsGroup'
import { useUpdateMfaStatus } from 'modules/security_settings/pages/SecuritySettingsPage/AuthSection/useUpdateMfaStatus'

import { TypedSecuritySettingsAuthSectionFragment } from './types'

interface MfaFormValues {
  mfaStatus: TypedSecuritySettingsAuthSectionFragment['mfaStatus']
}

function MfaForm({ mfaStatus }: TypedSecuritySettingsAuthSectionFragment) {
  const { updateMfaStatus, loading: updating } = useUpdateMfaStatus()

  const form = useForm<MfaFormValues>({
    defaultValues: {
      mfaStatus,
    },
    onSubmit: async (data) => {
      const result = await updateMfaStatus(data.mfaStatus)
      const handled = handleResult(result, (_formErrors) => {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('security_settings.auth.mfa.form.error_flash'),
          time: 60000, // 1 minute
        })
      })
      if (handled.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('common.saved_successfully'),
        })
        const handledMfaStatus = handled.data.companyConfig?.mfaStatus
        if (handledMfaStatus) {
          form.resetForm({ values: { mfaStatus: handledMfaStatus } })
        }
      }
      return handled
    },
  })

  const required = form.values.mfaStatus === 'required'

  function handleEnforcedChange() {
    const nextToggled = !required
    form.setFieldValue('mfaStatus', nextToggled ? 'required' : 'enabled')
  }

  return (
    <form onSubmit={form.handleSubmit}>
      <Box width="full" gap="s32">
        <SettingsGroup>
          <Box width="full" flexDirection="row" justifyContent="spaceBetween">
            <Text weight="semibold" size="300" color="grey1000">
              {i18n.t('security_settings.auth.mfa.form.enforce_mfa.label')}
            </Text>
            <TogglerCheckbox value={required} onChange={handleEnforcedChange} disabled={updating} />
          </Box>
        </SettingsGroup>
        <Box width="full" flexDirection="row" justifyContent="flexEnd">
          <Button disabled={!form.dirty || updating} submit>
            {i18n.t('common.save_changes')}
          </Button>
        </Box>
      </Box>
    </form>
  )
}

export default React.memo(MfaForm)
